import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useTheme } from '@mui/material/styles';

const CustomScrollbars = forwardRef(({ children, onScroll }, ref) => {
  const theme = useTheme();
  const scrollbarRef = useRef(null);

  useImperativeHandle(ref, () => ({
    scrollToTop: () => scrollbarRef.current?.scrollToTop(),
    scrollToBottom: () => scrollbarRef.current?.scrollToBottom(),
    getScrollTop: () => scrollbarRef.current?.getScrollTop(),
  }));

  return (
    <Scrollbars
      ref={scrollbarRef}
      onScrollFrame={({ top, scrollTop }) => {
        if (onScroll) {
          onScroll(scrollTop); // Send raw scrollTop value
        }
      }}
      autoHide
      autoHideDuration={1000}
      autoHideTimeout={500}
      style={{ height: '100%' }}
      renderTrackVertical={({ style, ...props }) => (
        <div
          {...props}
          style={{
            ...style,
            backgroundColor: theme.palette.mode === 'light' ? '#f0f0f0' : '#3c3c3c',
            width: '6px',
            borderRadius: '4px',
            right: '2px',
            position: 'absolute',
            bottom: '2px',
            top: '2px',
          }}
        />
      )}
      renderThumbVertical={({ style, ...props }) => (
        <div
          {...props}
          style={{
            ...style,
            backgroundColor: theme.palette.primary.main,
            borderRadius: '4px',
            width: '6px',
          }}
        />
      )}
    >
      {children}
    </Scrollbars>
  );
});

export default CustomScrollbars;
